import { regionIconById, labIconById } from "../powerChartIcons"
import { type PowerRegionData } from "../powerBubbleChartData"
import { type HoveredPowerItem } from "../hoveredPowerItem"
import { getLabsWorthShowing } from "./powerTooltipData"
import { TooltipRow } from "./DoPTooltipRow"

// One region and the labs nested beneath it. The whole group gains a left
// border when its flag or any of its labs is hovered, tying chart to tooltip.
export const RegionGroup = ({
  region,
  hoveredItem,
  hoveredRegionId,
  hasHover,
  largestComputeShown,
}: {
  region: PowerRegionData
  hoveredItem: HoveredPowerItem | null
  hoveredRegionId: string | null
  hasHover: boolean
  largestComputeShown: number
}) => {
  const labs = getLabsWorthShowing(region)
  const regionIsHovered = hoveredRegionId === region.id
  const showRegionRow = region.computeStock > 0
  if (!showRegionRow && labs.length === 0) return null
  return (
    <div
      className="mb-1 last:mb-0"
      style={{
        borderLeft: "1px solid transparent",
        borderLeftColor:
          hasHover && regionIsHovered ? "rgba(0, 0, 0, 0.5)" : "transparent",
      }}
    >
      <TooltipRow
        Icon={regionIconById[region.id]}
        label={region.name}
        compute={showRegionRow ? region.computeStock : undefined}
        barFraction={
          showRegionRow && largestComputeShown > 0
            ? region.computeStock / largestComputeShown
            : undefined
        }
        highlighted={regionIsHovered}
        dimmed={hasHover && !regionIsHovered}
        emphasized
      />
      {labs.map(lab => (
        <TooltipRow
          key={lab.id}
          Icon={labIconById[lab.id]}
          label={lab.name}
          compute={lab.compute}
          barFraction={
            largestComputeShown > 0 ? lab.compute / largestComputeShown : undefined
          }
          highlighted={hoveredItem?.kind === "lab" && hoveredItem.id === lab.id}
          dimmed={hasHover && lab.regionId !== hoveredRegionId}
          indented
        />
      ))}
    </div>
  )
}
